import React from "react";
import { Box, Flex, Group, Paper, Skeleton, Stack } from "@mantine/core";

// Mirrors CategoryCard's header: name on top, goal count underneath.
const CategoryCardSkeleton = () => {
  return (
    <Paper radius="lg" withBorder p="md">
      <Flex justify="space-between" align="flex-start" gap="sm" wrap="nowrap">
        <Flex gap="sm" align="flex-start" wrap="nowrap" sx={{ flex: 1, minWidth: 0 }}>
          <Box
            sx={{
              width: 8,
              height: 24,
              marginTop: 4,
              background: "#eee",
              borderRadius: 4,
              flexShrink: 0,
            }}
          />
          <Stack spacing={6}>
            <Skeleton height={18} width={160} radius="sm" />
            <Skeleton height={20} width={60} radius="xl" />
          </Stack>
        </Flex>
        <Group spacing="xs" noWrap sx={{ flexShrink: 0 }}>
          <Skeleton height={28} width={64} radius="sm" />
          <Skeleton height={28} width={28} circle />
          <Skeleton height={28} width={28} circle />
        </Group>
      </Flex>
      <Stack spacing="xs" mt="md">
        {Array.from({ length: 4 }).map((_, idx) => (
          <Skeleton key={idx} height={36} radius="sm" />
        ))}
      </Stack>
    </Paper>
  );
};

export default CategoryCardSkeleton;


